var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeekForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9117 29.9298C18.7978 38.6835 20.9378 50.7363 29.6916 56.8502C38.4453 62.9641 50.498 60.8241 56.612 52.0704C59.6694 47.6929 60.6631 42.4955 59.7974 37.6203C59.5641 36.3061 60.4402 35.0517 61.7544 34.8183C63.0685 34.585 64.323 35.4611 64.5563 36.7752C65.637 42.8611 64.3954 49.3674 60.5745 54.8379C52.9321 65.7801 37.8662 68.4552 26.924 60.8127C15.9818 53.1703 13.3068 38.1044 20.9492 27.1622C24.7701 21.6916 30.4512 18.2861 36.5371 17.2056C37.3857 17.0549 38.5464 16.8833 39.7573 16.7164L35.982 14.0797C34.8878 13.3154 34.6203 11.8088 35.3846 10.7146C36.1488 9.62039 37.6554 9.35288 38.7496 10.1171L47.6653 16.3442C48.7595 17.1084 49.027 18.615 48.2628 19.7092L42.0357 28.6249C41.2715 29.7191 39.7649 29.9866 38.6707 29.2224C37.5765 28.4582 37.309 26.9516 38.0732 25.8573L41.1863 21.4001C39.7354 21.5945 38.3219 21.7976 37.382 21.9645L37.382 21.9645C32.5067 22.8301 27.9691 25.5523 24.9117 29.9298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekForward);
export default __webpack_public_path__ + "static/media/SeekForward.3258e116a4bc109d2389f8c1f143168f.svg";
export { ForwardRef as ReactComponent };